<template>
  <div class="pb-offline-modal">
    <Asset src="Images/Logos/SVG/Nicolaudie-profile-builder.svg" />
    <h1>You are currently offline</h1>
    <p>Please connect to the internet to use Profile Builder.</p>
  </div>
</template>

<script setup lang="ts">
import Asset from '@nicolaudie-group/ng-ui-kit/components/Asset/Asset.vue'
</script>

<style lang="scss" scoped>
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';
@use '/src/styles/pb-util.scss';

.pb-offline-modal {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  bottom: 0;
  left: 0;
  text-align: center;
  @include flexbox.flexbox();
  @include flexbox.flex-direction(column);
  @include flexbox.align-items(center);
  @include flexbox.align-content(center);
  @include flexbox.justify-content(center);
  @include flexbox.flex-wrap(wrap);
  background-color: colors.$color-default--white;
  opacity: 1;

  h1 {
    margin: 10px;
    font: fonts.$font--weight-semibold 14px/18px fonts.$font--family;

    @include responsive.responsive-from-tablet() {
      font: fonts.$font--weight-semibold 18px/22px fonts.$font--family;
    }
  }

  @include theme.dark-theme {
    background-color: colors.$color-theme-dark--black-transparent;
    color: colors.$color-theme-dark--white;
  }

  &.v-enter-active {
    transition: opacity 0s ease;
  }

  &.v-leave-active {
    transition: opacity 0.2s ease;
  }

  &.v-enter-from,
  &.v-leave-to {
    opacity: 0;
  }
}
</style>
